import React, { useEffect } from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import OperatorReportTable from './operatorListTable';
import { useDispatch } from 'react-redux';
import { getMfgLinesList } from '../action';

const styles = makeStyles((theme: Theme) =>
    createStyles({
        mainContainer: {
            display: 'flex',
            height: '100%',
            width: '100%',
            overflow: 'auto',
            justifyContent: 'space-around',
            marginTop: '5px',
        },
        innerContainerLeft: {
            width: '100%',
            height: '100%',
            overflow: 'auto',
            '&::-webkit-scrollbar': {
                display: 'none !important',
            },
            padding: '5px'
        },
        innerContainerRight: {
            flexBasis: '48.2%',
            backgroundColor: 'var(--white)',
            padding: '18px 16px',
            height: '90vh',
            overflow: 'auto',
            paddingBottom: 0,
            '&::-webkit-scrollbar': {
                display: 'none !important',
            },
        },
    }),
);

export default function OperatorReport() {
    const classes = styles();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        dispatch(getMfgLinesList());
    }, [dispatch]);

    return (
        <div className={classes.mainContainer}>
            <Helmet>
                <title>{t('OperatorReport')}</title>
            </Helmet>
            <div className={classes.innerContainerLeft}>
                <OperatorReportTable />
            </div>
        </div>
    );
}
